<template>
  <div>
  <v-app>
    <div  v-if="checker" class="md-layout noprint ">
      <md-toolbar class=" md-info " style="width:100%">
        <div style="width:50%">
          <h3 class="md-title" style="flex:1; margin-left:10px;">
            
          </h3>
        </div>
        <!-- <md-button style="float: right; " class="noprint md-dense md-icon-button md-info" @click="printPage()" ><md-icon>print</md-icon></md-button> -->
        <!-- <md-menu md-direction="bottom-start" style="margin-right:20px;">
          <md-button class="nonprint; md-info md-icon-button md-dense" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
          <md-menu-content>
            <md-menu-item v-if="role.update " @click="editChecker(checker.id)">Edit</md-menu-item>
            <md-menu-item v-if="role.delete " @click="deleteConfirmation(checker.id)">Delete</md-menu-item>
            <md-menu-item @click="backtoList">Back to Checker list</md-menu-item> 
          </md-menu-content>
        </md-menu> -->
        <div style="width:50%; ">
          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense color md-info" @click="closeDetail()"><md-icon>close</md-icon></md-button>
          </div>
        </div>
      </md-toolbar>
      <div class="md-layout-item md-size-100">
        <md-card>
          <!-- <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Checker Info</h4>
            </div>
          </md-card-header> -->
          <md-card-content>
            <md-table >
              <md-table-row>
                <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:120px;">Checker Type</md-table-cell>
                <md-table-cell style="width:150px;">
                  <span v-if="checker.checker_type==0">Enter</span>
                  <span v-if="checker.checker_type==1">Exit</span>
                  <span v-if="checker.checker_type==2">Identification/Mapping</span>
                </md-table-cell>

                <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:150px;">BBM</md-table-cell>
                
                <md-table-cell style="width:150px;">
                  <span v-if="checker.checker_bbm==0">Penuh</span>
                    <span v-if="checker.checker_bbm==1">0</span>
                    <span v-if="checker.checker_bbm==2">0.5</span>
                    <span v-if="checker.checker_bbm==3">1</span>
                    <span v-if="checker.checker_bbm==4">1.5</span>
                    <span v-if="checker.checker_bbm==5">2</span>
                    <span v-if="checker.checker_bbm==6">2.5</span>
                    <span v-if="checker.checker_bbm==7">3</span>
                    <span v-if="checker.checker_bbm==8">3.5</span>
                    <span v-if="checker.checker_bbm==9">4</span>
                    <span v-if="checker.checker_bbm==10">4.5</span>
                    <span v-if="checker.checker_bbm==11">5</span>
                    <span v-if="checker.checker_bbm==12">5.5</span>
                    <span v-if="checker.checker_bbm==13">6</span>
                    <span v-if="checker.checker_bbm==14">6.5</span>
                    <span v-if="checker.checker_bbm==15">7</span>
                    <span v-if="checker.checker_bbm==16">7.5</span>
                    <span v-if="checker.checker_bbm==17">8</span>
                </md-table-cell>
                
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:120px;">Eshed</md-table-cell>
                <md-table-cell style="width:150px;">
                  <span v-if="checker.checker_pool!=null">{{ checker.checker_pool.pool_name }}</span>
                  <span v-else style="color:#aaaa">-</span>
                  </md-table-cell>

                <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:150px;">KM / KM MSPF</md-table-cell>
                <md-table-cell v-if="!checker.checker_km && !checker.checker_km_mspf" style="color:#aaaa; width:150px; ">-</md-table-cell>
                <md-table-cell v-else style="width:150px;">{{checker.checker_km+' / '+checker.checker_km_mspf}}</md-table-cell>
                
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:120px;">Plate No</md-table-cell>
                <md-table-cell style="width:150px;"> {{ checker.checker_vehicle?checker.checker_vehicle.vehicle_plate_no:null }}
                </md-table-cell>

                <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:150px;">RIT</md-table-cell>
                <md-table-cell v-if="!checker.checker_rit" style="color:#aaaa; width:150px; ">-</md-table-cell>
                <md-table-cell v-else style="width:150px;">{{checker.checker_rit}}</md-table-cell>
                
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:120px;">Vehicle No</md-table-cell>
                <md-table-cell style="width:150px;"> {{ checker.checker_vehicle?checker.checker_vehicle.vehicle_door_no:null }}
                </md-table-cell>

                <md-table-cell class="md-info" style="text-align:left; font-weight:bold; width:150px;">Drop</md-table-cell>
                <md-table-cell v-if="!checker.checker_drop" style="color:#aaaa; width:150px; ">-</md-table-cell>
                <md-table-cell v-else style="width:150px;">{{checker.checker_drop}}</md-table-cell>
                
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-100">
        <tabs
          :tab-active="1"
          :tab-name="['Dalam Mobil', 'Luar Mobil', 'Mesin Mobil'
          ,'Perlengkapan Lain','Kelengkapan Taksi','Body Mobil']"
          color-button="info"
          plain>
          
          <template slot="tab-pane-1" class="justify-content">
            <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam1"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item1">
                      <h4 style="font-weight:bold;">Item</h4>
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image1">
                      <h4 style="font-weight:bold;">Image</h4>
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam1">
                    <v-tab-item
                      value="tab_bag_dalam-item1"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left; font-weight:bold;"><b>Item</b></md-table-head>
                            <md-table-head style="text-align:left; font-weight:bold;"><b>Check</b></md-table-head>
                            <md-table-head style="text-align:center; font-weight:bold;"><b>Remark</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kunci Utama</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kunci">-</span>
                              <span v-if="checker.checker_kunci==1">Ada</span>
                              <span v-if="checker.checker_kunci==2">Tidak Ada</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kunci_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kunci_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kunci Cadangan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kunci_cadangan">-</span>
                              <span v-if="checker.checker_kunci_cadangan==1">Ada</span>
                              <span v-if="checker.checker_kunci_cadangan==2">Tidak Ada</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kunci_cadangan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kunci_cadangan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Putaran Mesin</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_putaran_mesin">-</span>
                              <span v-if="checker.checker_putaran_mesin==1">Baik</span>
                              <span v-if="checker.checker_putaran_mesin==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_putaran_mesin==3">Hilang</span>
                              <span v-if="checker.checker_putaran_mesin==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_putaran_mesin_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_putaran_mesin_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Rem Tangan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_rem_tangan">-</span>
                              <span v-if="checker.checker_rem_tangan==1">Baik</span>
                              <span v-if="checker.checker_rem_tangan==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_rem_tangan==3">Hilang</span>
                              <span v-if="checker.checker_rem_tangan==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_rem_tangan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_rem_tangan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pedal</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pedal">-</span>
                              <span v-if="checker.checker_pedal==1">Baik</span>
                              <span v-if="checker.checker_pedal==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_pedal==3">Hilang</span>
                              <span v-if="checker.checker_pedal==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pedal_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pedal_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Klakson</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_posisi_stir_dan_klakson">-</span>
                              <span v-if="checker.checker_posisi_stir_dan_klakson==1">Baik</span>
                              <span v-if="checker.checker_posisi_stir_dan_klakson==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_posisi_stir_dan_klakson==3">Hilang</span>
                              <span v-if="checker.checker_posisi_stir_dan_klakson==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_posisi_stir_dan_klakson_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_posisi_stir_dan_klakson_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <!-- <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kartu Oli dan Maintenance</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kartu_oli_dan_maintenance">-</span>
                              <span v-if="checker.checker_kartu_oli_dan_maintenance==1">Baik</span>
                              <span v-if="checker.checker_kartu_oli_dan_maintenance==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_kartu_oli_dan_maintenance==3">Hilang</span>
                              <span v-if="checker.checker_kartu_oli_dan_maintenance==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kartu_oli_dan_maintenance_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kartu_oli_dan_maintenance_remark }}</span>
                            </md-table-cell>
                          </md-table-row> -->
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Wiper Depan/Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_wiper_depan_belakang">-</span>
                              <span v-if="checker.checker_wiper_depan_belakang==1">Baik</span>
                              <span v-if="checker.checker_wiper_depan_belakang==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_wiper_depan_belakang==3">Hilang</span>
                              <span v-if="checker.checker_wiper_depan_belakang==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_wiper_depan_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_wiper_depan_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Sign</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_sign">-</span>
                              <span v-if="checker.checker_lampu_sign==1">Baik</span>
                              <span v-if="checker.checker_lampu_sign==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_sign==3">Hilang</span>
                              <span v-if="checker.checker_lampu_sign==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_sign_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_sign_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Baca</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_baca">-</span>
                              <span v-if="checker.checker_lampu_baca==1">Baik</span>
                              <span v-if="checker.checker_lampu_baca==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_baca==3">Hilang</span>
                              <span v-if="checker.checker_lampu_baca==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_baca_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_baca_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Utama Depan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_utama_depan">-</span>
                              <span v-if="checker.checker_lampu_utama_depan==1">Baik</span>
                              <span v-if="checker.checker_lampu_utama_depan==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_utama_depan==3">Hilang</span>
                              <span v-if="checker.checker_lampu_utama_depan==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_utama_depan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_utama_depan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Rem</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_rem">-</span>
                              <span v-if="checker.checker_lampu_rem==1">Baik</span>
                              <span v-if="checker.checker_lampu_rem==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_rem==3">Hilang</span>
                              <span v-if="checker.checker_lampu_rem==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_rem_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_rem_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Mundur</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_mundur">-</span>
                              <span v-if="checker.checker_lampu_mundur==1">Baik</span>
                              <span v-if="checker.checker_lampu_mundur==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_mundur==3">Hilang</span>
                              <span v-if="checker.checker_lampu_mundur==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_mundur_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_mundur_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Power Window</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_power_window">-</span>
                              <span v-if="checker.checker_power_window==1">Baik</span>
                              <span v-if="checker.checker_power_window==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_power_window==3">Hilang</span>
                              <span v-if="checker.checker_power_window==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_power_window_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_power_window_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Central Lock</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_central_lock">-</span>
                              <span v-if="checker.checker_central_lock==1">Baik</span>
                              <span v-if="checker.checker_central_lock==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_central_lock==3">Hilang</span>
                              <span v-if="checker.checker_central_lock==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_central_lock_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_central_lock_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Elektrik Mirror</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_elektrik_mirror">-</span>
                              <span v-if="checker.checker_elektrik_mirror==1">Baik</span>
                              <span v-if="checker.checker_elektrik_mirror==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_elektrik_mirror==3">Hilang</span>
                              <span v-if="checker.checker_elektrik_mirror==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_elektrik_mirror_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_elektrik_mirror_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">AC</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_ac">-</span>
                              <span v-if="checker.checker_ac==1">Baik</span>
                              <span v-if="checker.checker_ac==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_ac==3">Hilang</span>
                              <span v-if="checker.checker_ac==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_ac_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_ac_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">STNK</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_stnk">-</span>
                              <span v-if="checker.checker_stnk==1">Ada</span>
                              <span v-if="checker.checker_stnk==2">Hlang</span>
                              <span v-if="checker.checker_stnk==3">Tilang</span>
                              <span v-if="checker.checker_stnk==4">Perpanjang STNK</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_stnk_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_stnk_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <!-- <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lighter</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lighter">-</span>
                              <span v-if="checker.checker_lighter==1">Baik</span>
                              <span v-if="checker.checker_lighter==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lighter==3">Hilang</span>
                              <span v-if="checker.checker_lighter==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lighter_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lighter_remark }}</span>
                            </md-table-cell>
                          </md-table-row> -->
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Safety Belt</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_safety_belt">-</span>
                              <span v-if="checker.checker_safety_belt==1">Baik</span>
                              <span v-if="checker.checker_safety_belt==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_safety_belt==3">Hilang</span>
                              <span v-if="checker.checker_safety_belt==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_safety_belt_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_safety_belt_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Head Rest</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_head_rest">-</span>
                              <span v-if="checker.checker_head_rest==1">Baik</span>
                              <span v-if="checker.checker_head_rest==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_head_rest==3">Hilang</span>
                              <span v-if="checker.checker_head_rest==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_head_rest_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_head_rest_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Head Unit</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_head_unit">-</span>
                              <span v-if="checker.checker_head_unit==1">Baik</span>
                              <span v-if="checker.checker_head_unit==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_head_unit==3">Hilang</span>
                              <span v-if="checker.checker_head_unit==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_head_unit_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_head_unit_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Remote Head Unit</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_remote_head_unit">-</span>
                              <span v-if="checker.checker_remote_head_unit==1">Baik</span>
                              <span v-if="checker.checker_remote_head_unit==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_remote_head_unit==3">Hilang</span>
                              <span v-if="checker.checker_remote_head_unit==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_remote_head_unit_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_remote_head_unit_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">MCCS</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_mccs">-</span>
                              <span v-if="checker.checker_mccs==1">Baik</span>
                              <span v-if="checker.checker_mccs==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_mccs==3">Hilang</span>
                              <span v-if="checker.checker_mccs==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_mccs_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_mccs_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Sarung Jok</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_sarung_jok">-</span>
                              <span v-if="checker.checker_sarung_jok==1">Ada</span>
                              <span v-if="checker.checker_sarung_jok==2">Tidak Ada</span>
                              <span v-if="checker.checker_sarung_jok==3">Rusak</span>
                              <span v-if="checker.checker_sarung_jok==4">Robek</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_sarung_jok_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_sarung_jok_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Karpet Dasar</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_karpet_dasar">-</span>
                              <span v-if="checker.checker_karpet_dasar==1">Baik</span>
                              <span v-if="checker.checker_karpet_dasar==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_karpet_dasar==3">Hilang</span>
                              <span v-if="checker.checker_karpet_dasar==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_karpet_dasar_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_karpet_dasar_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <!-- <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Asbak Depan/Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_asbak_depan_belakang">-</span>
                              <span v-if="checker.checker_asbak_depan_belakang==1">Baik</span>
                              <span v-if="checker.checker_asbak_depan_belakang==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_asbak_depan_belakang==3">Hilang</span>
                              <span v-if="checker.checker_asbak_depan_belakang==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_asbak_depan_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_asbak_depan_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row> -->
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Speedometer</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_speedometer">-</span>
                              <span v-if="checker.checker_speedometer==1">Baik</span>
                              <span v-if="checker.checker_speedometer==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_speedometer==3">Hilang</span>
                              <span v-if="checker.checker_speedometer==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_speedometer_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_speedometer_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image1"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_dalam" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                    
                </v-card>
          </template>
          <template slot="tab-pane-2">
            <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam2"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item2">
                      <h4 style="font-weight:bold;">Item</h4>
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image2">
                      <h4 style="font-weight:bold;">Image</h4>
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam2">
                    <v-tab-item
                      value="tab_bag_dalam-item2"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>Item</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>Check</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Cat Kap Mesin</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_cat_kap_mesin">-</span>
                              <span v-if="checker.checker_cat_kap_mesin==1">Baik</span>
                              <span v-if="checker.checker_cat_kap_mesin==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_cat_kap_mesin==3">Hilang</span>
                              <span v-if="checker.checker_cat_kap_mesin==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_cat_kap_mesin_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_cat_kap_mesin_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Cat Bumper Spakboard</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_cat_bumper_spakboard">-</span>
                              <span v-if="checker.checker_cat_bumper_spakboard==1">Baik</span>
                              <span v-if="checker.checker_cat_bumper_spakboard==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_cat_bumper_spakboard==3">Hilang</span>
                              <span v-if="checker.checker_cat_bumper_spakboard==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_cat_bumper_spakboard_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_cat_bumper_spakboard_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Cat Pintu</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_cat_pintu">-</span>
                              <span v-if="checker.checker_cat_pintu==1">Baik</span>
                              <span v-if="checker.checker_cat_pintu==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_cat_pintu==3">Hilang</span>
                              <span v-if="checker.checker_cat_pintu==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_cat_pintu_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_cat_pintu_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Mika Lampu</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_mika_lampu">-</span>
                              <span v-if="checker.checker_mika_lampu==1">Baik</span>
                              <span v-if="checker.checker_mika_lampu==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_mika_lampu==3">Hilang</span>
                              <span v-if="checker.checker_mika_lampu==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_mika_lampu_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_mika_lampu_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Ban</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_ban">-</span>
                              <span v-if="checker.checker_ban==1">Tebal</span>
                              <span v-if="checker.checker_ban==2">Sedang</span>
                              <span v-if="checker.checker_ban==3">Tipis</span>
                              <span v-if="checker.checker_ban==4">Sangat Tipis</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_ban_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_ban_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Velg</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_velg">-</span>
                              <span v-if="checker.checker_velg==1">Baik</span>
                              <span v-if="checker.checker_velg==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_velg==3">Hilang</span>
                              <span v-if="checker.checker_velg==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_velg_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_velg_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Dop Roda</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_dop_roda">-</span>
                              <span v-if="checker.checker_dop_roda==1">Baik</span>
                              <span v-if="checker.checker_dop_roda==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_dop_roda==3">Hilang</span>
                              <span v-if="checker.checker_dop_roda==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_dop_roda_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_dop_roda_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kembang Ban</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kembang_ban">-</span>
                              <span v-if="checker.checker_kembang_ban==1">Baik</span>
                              <span v-if="checker.checker_kembang_ban==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_kembang_ban==3">Hilang</span>
                              <span v-if="checker.checker_kembang_ban==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kembang_ban_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kembang_ban_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Film</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_film">-</span>
                              <span v-if="checker.checker_kaca_film==1">Baik</span>
                              <span v-if="checker.checker_kaca_film==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_kaca_film==3">Hilang</span>
                              <span v-if="checker.checker_kaca_film==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_film_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_film_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kunci Pintu</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kunci_pintu">-</span>
                              <span v-if="checker.checker_kunci_pintu==1">Ada</span>
                              <span v-if="checker.checker_kunci_pintu==2">Tidak Ada</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kunci_pintu_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kunci_pintu_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Emblem Sticker</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_emblem_sticker">-</span>
                              <span v-if="checker.checker_emblem_sticker==1">Baik</span>
                              <span v-if="checker.checker_emblem_sticker==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_emblem_sticker==3">Hilang</span>
                              <span v-if="checker.checker_emblem_sticker==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_emblem_sticker_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_emblem_sticker_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Ban Cadangan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_ban_cadangan">-</span>
                              <span v-if="checker.checker_ban_cadangan==1">Baik</span>
                              <span v-if="checker.checker_ban_cadangan==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_ban_cadangan==3">Hilang</span>
                              <span v-if="checker.checker_ban_cadangan==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_ban_cadangan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_ban_cadangan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image2"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_luar" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>

          </template>
          <template slot="tab-pane-3">
            <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam3"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item3">
                      <h4 style="font-weight:bold;">Item</h4>
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image3">
                      <h4 style="font-weight:bold;">Image</h4>
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam3">
                    <v-tab-item
                      value="tab_bag_dalam-item3"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>Item</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>Check</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Oli Mesin</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_oli_mesin">-</span>
                              <span v-if="checker.checker_oli_mesin==1">Baik</span>
                              <span v-if="checker.checker_oli_mesin==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_oli_mesin==3">Hilang</span>
                              <span v-if="checker.checker_oli_mesin==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_oli_mesin_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_oli_mesin_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Air dan Tutup Radiator</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_air_dan_tutup_radiator">-</span>
                              <span v-if="checker.checker_air_dan_tutup_radiator==1">Baik</span>
                              <span v-if="checker.checker_air_dan_tutup_radiator==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_air_dan_tutup_radiator==3">Hilang</span>
                              <span v-if="checker.checker_air_dan_tutup_radiator==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_air_dan_tutup_radiator_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_air_dan_tutup_radiator_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Accu</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_accu">-</span>
                              <span v-if="checker.checker_accu==1">Baik</span>
                              <span v-if="checker.checker_accu==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_accu==3">Hilang</span>
                              <span v-if="checker.checker_accu==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_accu_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_accu_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Tali Kipas</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_tali_kipas">-</span>
                              <span v-if="checker.checker_tali_kipas==1">Baik</span>
                              <span v-if="checker.checker_tali_kipas==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_tali_kipas==3">Hilang</span>
                              <span v-if="checker.checker_tali_kipas==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_tali_kipas_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_tali_kipas_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Minyak Rem</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_minyak_rem">-</span>
                              <span v-if="checker.checker_minyak_rem==1">Baik</span>
                              <span v-if="checker.checker_minyak_rem==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_minyak_rem==3">Hilang</span>
                              <span v-if="checker.checker_minyak_rem==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_minyak_rem_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_minyak_rem_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image3"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_mesin" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
          </template>
          <template slot="tab-pane-4">
            <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam4"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item4">
                      <h4 style="font-weight:bold;">Item</h4>
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image4">
                      <h4 style="font-weight:bold;">Image</h4>
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam4">
                    <v-tab-item
                      value="tab_bag_dalam-item4"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>Item</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>Check</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Dongkrak dan Kunci Roda</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_dongkrak">-</span>
                              <span v-if="checker.checker_dongkrak==1">Baik</span>
                              <span v-if="checker.checker_dongkrak==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_dongkrak==3">Hilang</span>
                              <span v-if="checker.checker_dongkrak==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_dongkrak_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_dongkrak_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Ban Serep</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_ban_serep_dan_kunci_roda">-</span>
                              <span v-if="checker.checker_ban_serep_dan_kunci_roda==1">Baik</span>
                              <span v-if="checker.checker_ban_serep_dan_kunci_roda==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_ban_serep_dan_kunci_roda==3">Hilang</span>
                              <span v-if="checker.checker_ban_serep_dan_kunci_roda==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_ban_serep_dan_kunci_roda_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_ban_serep_dan_kunci_roda_remark }}</span>
                            </md-table-cell>
                          </md-table-row> 
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Segitiga Pengaman</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_segitiga_pengaman">-</span>
                              <span v-if="checker.checker_segitiga_pengaman==1">Baik</span>
                              <span v-if="checker.checker_segitiga_pengaman==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_segitiga_pengaman==3">Hilang</span>
                              <span v-if="checker.checker_segitiga_pengaman==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_segitiga_pengaman_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_segitiga_pengaman_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Karpet Bagasi</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_karpet_bagasi">-</span>
                              <span v-if="checker.checker_karpet_bagasi==1">Baik</span>
                              <span v-if="checker.checker_karpet_bagasi==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_karpet_bagasi==3">Hilang</span>
                              <span v-if="checker.checker_karpet_bagasi==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_karpet_bagasi_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_karpet_bagasi_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">P3K</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_p3k">-</span>
                              <span v-if="checker.checker_p3k==1">Baik</span>
                              <span v-if="checker.checker_p3k==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_p3k==3">Hilang</span>
                              <span v-if="checker.checker_p3k==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_p3k_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_p3k_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image4"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_lain" :key="index">
                            <md-table-cell>
                              <viewer style="margin:auto;" class="pointer photo_list" :src="item.url_photo_file">
                                <img :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
          </template>
          <template slot="tab-pane-5">
            <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam5"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item5">
                      <h4 style="font-weight:bold;">Item</h4>
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image5">
                      <h4 style="font-weight:bold;">Image</h4>
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam5">
                    <v-tab-item
                      value="tab_bag_dalam-item5"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>Item</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>Check</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Mahkota</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_mahkota">-</span>
                              <span v-if="checker.checker_mahkota==1">Baik</span>
                              <span v-if="checker.checker_mahkota==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_mahkota==3">Hilang</span>
                              <span v-if="checker.checker_mahkota==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_mahkota_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_mahkota_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Argometer</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_argometer">-</span>
                              <span v-if="checker.checker_argometer==1">Baik</span>
                              <span v-if="checker.checker_argometer==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_argometer==3">Hilang</span>
                              <span v-if="checker.checker_argometer==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_argometer_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_argometer_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Bahaya</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_bahaya">-</span>
                              <span v-if="checker.checker_lampu_bahaya==1">Baik</span>
                              <span v-if="checker.checker_lampu_bahaya==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_bahaya==3">Hilang</span>
                              <span v-if="checker.checker_lampu_bahaya==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_bahaya_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_bahaya_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Sticker Atribut Taksi</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_sticker_atribut_taksi">-</span>
                              <span v-if="checker.checker_sticker_atribut_taksi==1">Baik</span>
                              <span v-if="checker.checker_sticker_atribut_taksi==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_sticker_atribut_taksi==3">Hilang</span>
                              <span v-if="checker.checker_sticker_atribut_taksi==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_sticker_atribut_taksi_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_sticker_atribut_taksi_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Vacant</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_vacant">-</span>
                              <span v-if="checker.checker_lampu_vacant==1">Baik</span>
                              <span v-if="checker.checker_lampu_vacant==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_vacant==3">Hilang</span>
                              <span v-if="checker.checker_lampu_vacant==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_vacant_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_vacant_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image5"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_taxi" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
          </template>
          <template slot="tab-pane-6">
            <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam6"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item6">
                      <h4 style="font-weight:bold;">Item</h4>
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image6">
                      <h4 style="font-weight:bold;">Image</h4>
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam6">
                    <v-tab-item
                      value="tab_bag_dalam-item6"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>Item</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>Check</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kap Mesin</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kap_mesin">-</span>
                              <span v-if="checker.checker_kap_mesin==1">Penyot</span>
                              <span v-if="checker.checker_kap_mesin==2">Lecet</span>
                              <span v-if="checker.checker_kap_mesin==3">Baret</span>
                              <span v-if="checker.checker_kap_mesin==4">Dekok</span>
                              <span v-if="checker.checker_kap_mesin==5">Pecah</span>
                              <span v-if="checker.checker_kap_mesin==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kap_mesin_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kap_mesin_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Fender Depan Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_fender_depan_kiri">-</span>
                              <span v-if="checker.checker_fender_depan_kiri==1">Penyot</span>
                              <span v-if="checker.checker_fender_depan_kiri==2">Lecet</span>
                              <span v-if="checker.checker_fender_depan_kiri==3">Baret</span>
                              <span v-if="checker.checker_fender_depan_kiri==4">Dekok</span>
                              <span v-if="checker.checker_fender_depan_kiri==5">Pecah</span>
                              <span v-if="checker.checker_fender_depan_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_fender_depan_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_fender_depan_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Fender Depan Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_fender_depan_kanan">-</span>
                              <span v-if="checker.checker_fender_depan_kanan==1">Penyot</span>
                              <span v-if="checker.checker_fender_depan_kanan==2">Lecet</span>
                              <span v-if="checker.checker_fender_depan_kanan==3">Baret</span>
                              <span v-if="checker.checker_fender_depan_kanan==4">Dekok</span>
                              <span v-if="checker.checker_fender_depan_kanan==5">Pecah</span>
                              <span v-if="checker.checker_fender_depan_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_fender_depan_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_fender_depan_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Spion Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_spion_kiri">-</span>
                              <span v-if="checker.checker_spion_kiri==1">Penyot</span>
                              <span v-if="checker.checker_spion_kiri==2">Lecet</span>
                              <span v-if="checker.checker_spion_kiri==3">Baret</span>
                              <span v-if="checker.checker_spion_kiri==4">Dekok</span>
                              <span v-if="checker.checker_spion_kiri==5">Pecah</span>
                              <span v-if="checker.checker_spion_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_spion_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_spion_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Spion Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_cover_spion_kiri">-</span>
                              <span v-if="checker.checker_cover_spion_kiri==1">Penyot</span>
                              <span v-if="checker.checker_cover_spion_kiri==2">Lecet</span>
                              <span v-if="checker.checker_cover_spion_kiri==3">Baret</span>
                              <span v-if="checker.checker_cover_spion_kiri==4">Dekok</span>
                              <span v-if="checker.checker_cover_spion_kiri==5">Pecah</span>
                              <span v-if="checker.checker_cover_spion_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_cover_spion_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_cover_spion_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Spion Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_spion_kanan">-</span>
                              <span v-if="checker.checker_spion_kanan==1">Penyot</span>
                              <span v-if="checker.checker_spion_kanan==2">Lecet</span>
                              <span v-if="checker.checker_spion_kanan==3">Baret</span>
                              <span v-if="checker.checker_spion_kanan==4">Dekok</span>
                              <span v-if="checker.checker_spion_kanan==5">Pecah</span>
                              <span v-if="checker.checker_spion_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_spion_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_spion_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Spion Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_cover_spion_kanan">-</span>
                              <span v-if="checker.checker_cover_spion_kanan==1">Penyot</span>
                              <span v-if="checker.checker_cover_spion_kanan==2">Lecet</span>
                              <span v-if="checker.checker_cover_spion_kanan==3">Baret</span>
                              <span v-if="checker.checker_cover_spion_kanan==4">Dekok</span>
                              <span v-if="checker.checker_cover_spion_kanan==5">Pecah</span>
                              <span v-if="checker.checker_cover_spion_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_cover_spion_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_cover_spion_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Bemper Depan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_bemper_depan">-</span>
                              <span v-if="checker.checker_bemper_depan==1">Penyot</span>
                              <span v-if="checker.checker_bemper_depan==2">Lecet</span>
                              <span v-if="checker.checker_bemper_depan==3">Baret</span>
                              <span v-if="checker.checker_bemper_depan==4">Dekok</span>
                              <span v-if="checker.checker_bemper_depan==5">Pecah</span>
                              <span v-if="checker.checker_bemper_depan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_bemper_depan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_bemper_depan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Depan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_depan">-</span>
                              <span v-if="checker.checker_kaca_depan==1">Penyot</span>
                              <span v-if="checker.checker_kaca_depan==2">Lecet</span>
                              <span v-if="checker.checker_kaca_depan==3">Baret</span>
                              <span v-if="checker.checker_kaca_depan==4">Dekok</span>
                              <span v-if="checker.checker_kaca_depan==5">Pecah</span>
                              <span v-if="checker.checker_kaca_depan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_depan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_depan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_belakang">-</span>
                              <span v-if="checker.checker_kaca_belakang==1">Penyot</span>
                              <span v-if="checker.checker_kaca_belakang==2">Lecet</span>
                              <span v-if="checker.checker_kaca_belakang==3">Baret</span>
                              <span v-if="checker.checker_kaca_belakang==4">Dekok</span>
                              <span v-if="checker.checker_kaca_belakang==5">Pecah</span>
                              <span v-if="checker.checker_kaca_belakang==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Pintu Depan Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_pintu_depan_kiri">-</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==1">Penyot</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==2">Lecet</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==3">Baret</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==4">Dekok</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==5">Pecah</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_pintu_depan_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_pintu_depan_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Pintu Depan Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_pintu_depan_kanan">-</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==1">Penyot</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==2">Lecet</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==3">Baret</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==4">Dekok</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==5">Pecah</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_pintu_depan_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_pintu_depan_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Pintu Belakang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_pintu_belakang_kiri">-</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==3">Baret</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_pintu_belakang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_pintu_belakang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Depan Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_depan_kanan">-</span>
                              <span v-if="checker.checker_pintu_depan_kanan==1">Penyot</span>
                              <span v-if="checker.checker_pintu_depan_kanan==2">Lecet</span>
                              <span v-if="checker.checker_pintu_depan_kanan==3">Baret</span>
                              <span v-if="checker.checker_pintu_depan_kanan==4">Dekok</span>
                              <span v-if="checker.checker_pintu_depan_kanan==5">Pecah</span>
                              <span v-if="checker.checker_pintu_depan_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_depan_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_depan_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Belakang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_belakang_kiri">-</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==3">Baret</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_belakang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_belakang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Depan Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_depan_kiri">-</span>
                              <span v-if="checker.checker_pintu_depan_kiri==1">Penyot</span>
                              <span v-if="checker.checker_pintu_depan_kiri==2">Lecet</span>
                              <span v-if="checker.checker_pintu_depan_kiri==3">Baret</span>
                              <span v-if="checker.checker_pintu_depan_kiri==4">Dekok</span>
                              <span v-if="checker.checker_pintu_depan_kiri==5">Pecah</span>
                              <span v-if="checker.checker_pintu_depan_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_depan_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_depan_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Belakang Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_belakang_kanan">-</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==1">Penyot</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==2">Lecet</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==3">Baret</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==4">Dekok</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==5">Pecah</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_belakang_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_belakang_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Fender Belakang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_fender_belakang_kiri">-</span>
                              <span v-if="checker.checker_fender_belakang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_fender_belakang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_fender_belakang_kiri==3">Baret</span>
                              <span v-if="checker.checker_fender_belakang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_fender_belakang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_fender_belakang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_fender_belakang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_fender_belakang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Fender Belakang Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_fender_belakang_kanan">-</span>
                              <span v-if="checker.checker_fender_belakang_kanan==1">Penyot</span>
                              <span v-if="checker.checker_fender_belakang_kanan==2">Lecet</span>
                              <span v-if="checker.checker_fender_belakang_kanan==3">Baret</span>
                              <span v-if="checker.checker_fender_belakang_kanan==4">Dekok</span>
                              <span v-if="checker.checker_fender_belakang_kanan==5">Pecah</span>
                              <span v-if="checker.checker_fender_belakang_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_fender_belakang_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_fender_belakang_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Gril Depan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_gril_depan">-</span>
                              <span v-if="checker.checker_gril_depan==1">Penyot</span>
                              <span v-if="checker.checker_gril_depan==2">Lecet</span>
                              <span v-if="checker.checker_gril_depan==3">Baret</span>
                              <span v-if="checker.checker_gril_depan==4">Dekok</span>
                              <span v-if="checker.checker_gril_depan==5">Pecah</span>
                              <span v-if="checker.checker_gril_depan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_gril_depan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_gril_depan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Gril Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_gril_belakang">-</span>
                              <span v-if="checker.checker_gril_belakang==1">Penyot</span>
                              <span v-if="checker.checker_gril_belakang==2">Lecet</span>
                              <span v-if="checker.checker_gril_belakang==3">Baret</span>
                              <span v-if="checker.checker_gril_belakang==4">Dekok</span>
                              <span v-if="checker.checker_gril_belakang==5">Pecah</span>
                              <span v-if="checker.checker_gril_belakang==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_gril_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_gril_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">List Plang Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_list_plang_kanan">-</span>
                              <span v-if="checker.checker_list_plang_kanan==1">Penyot</span>
                              <span v-if="checker.checker_list_plang_kanan==2">Lecet</span>
                              <span v-if="checker.checker_list_plang_kanan==3">Baret</span>
                              <span v-if="checker.checker_list_plang_kanan==4">Dekok</span>
                              <span v-if="checker.checker_list_plang_kanan==5">Pecah</span>
                              <span v-if="checker.checker_list_plang_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_list_plang_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_list_plang_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">List Plang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_list_plang_kiri">-</span>
                              <span v-if="checker.checker_list_plang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_list_plang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_list_plang_kiri==3">Baret</span>
                              <span v-if="checker.checker_list_plang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_list_plang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_list_plang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_list_plang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_list_plang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Atap Remark</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_atap_remark">-</span>
                              <span v-if="checker.checker_atap_remark==1">Penyot</span>
                              <span v-if="checker.checker_atap_remark==2">Lecet</span>
                              <span v-if="checker.checker_atap_remark==3">Baret</span>
                              <span v-if="checker.checker_atap_remark==4">Dekok</span>
                              <span v-if="checker.checker_atap_remark==5">Pecah</span>
                              <span v-if="checker.checker_atap_remark==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_atap_remark_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_atap_remark_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_belakang">-</span>
                              <span v-if="checker.checker_pintu_belakang==1">Penyot</span>
                              <span v-if="checker.checker_pintu_belakang==2">Lecet</span>
                              <span v-if="checker.checker_pintu_belakang==3">Baret</span>
                              <span v-if="checker.checker_pintu_belakang==4">Dekok</span>
                              <span v-if="checker.checker_pintu_belakang==5">Pecah</span>
                              <span v-if="checker.checker_pintu_belakang==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Roda Depan Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_roda_depan_kiri">-</span>
                              <span v-if="checker.checker_roda_depan_kiri==1">Penyot</span>
                              <span v-if="checker.checker_roda_depan_kiri==2">Lecet</span>
                              <span v-if="checker.checker_roda_depan_kiri==3">Baret</span>
                              <span v-if="checker.checker_roda_depan_kiri==4">Dekok</span>
                              <span v-if="checker.checker_roda_depan_kiri==5">Pecah</span>
                              <span v-if="checker.checker_roda_depan_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_roda_depan_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_roda_depan_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Roda Depan Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_roda_depan_kanan">-</span>
                              <span v-if="checker.checker_roda_depan_kanan==1">Penyot</span>
                              <span v-if="checker.checker_roda_depan_kanan==2">Lecet</span>
                              <span v-if="checker.checker_roda_depan_kanan==3">Baret</span>
                              <span v-if="checker.checker_roda_depan_kanan==4">Dekok</span>
                              <span v-if="checker.checker_roda_depan_kanan==5">Pecah</span>
                              <span v-if="checker.checker_roda_depan_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_roda_depan_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_roda_depan_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Roda Belakang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_roda_belakang_kiri">-</span>
                              <span v-if="checker.checker_roda_belakang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_roda_belakang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_roda_belakang_kiri==3">Baret</span>
                              <span v-if="checker.checker_roda_belakang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_roda_belakang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_roda_belakang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_roda_belakang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_roda_belakang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Roda Belakang Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_roda_belakang_kanan">-</span>
                              <span v-if="checker.checker_roda_belakang_kanan==1">Penyot</span>
                              <span v-if="checker.checker_roda_belakang_kanan==2">Lecet</span>
                              <span v-if="checker.checker_roda_belakang_kanan==3">Baret</span>
                              <span v-if="checker.checker_roda_belakang_kanan==4">Dekok</span>
                              <span v-if="checker.checker_roda_belakang_kanan==5">Pecah</span>
                              <span v-if="checker.checker_roda_belakang_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_roda_belakang_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_roda_belakang_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image6"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_body" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
          </template>
        </tabs>
        
        <!-- <nav-tabs-card>
          <template slot="content">
            <md-tabs class="md-success" md-alignment="centered">
              <md-tab id="tab-pages" style="margin-bottom:20px;" md-label="Dalam Mobil">
                <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam1"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item1">
                      Item
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image1">
                      Image
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam1">
                    <v-tab-item
                      value="tab_bag_dalam-item1"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>ITEM</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>CHECK</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>REMARK</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kunci</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kunci">-</span>
                              <span v-if="checker.checker_kunci==1">Baik</span>
                              <span v-if="checker.checker_kunci==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_kunci==3">Hilang</span>
                              <span v-if="checker.checker_kunci==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kunci_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kunci_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Putaran Mesin</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_putaran_mesin">-</span>
                              <span v-if="checker.checker_putaran_mesin==1">Baik</span>
                              <span v-if="checker.checker_putaran_mesin==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_putaran_mesin==3">Hilang</span>
                              <span v-if="checker.checker_putaran_mesin==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_putaran_mesin_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_putaran_mesin_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Rem Tangan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_rem_tangan">-</span>
                              <span v-if="checker.checker_rem_tangan==1">Baik</span>
                              <span v-if="checker.checker_rem_tangan==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_rem_tangan==3">Hilang</span>
                              <span v-if="checker.checker_rem_tangan==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_rem_tangan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_rem_tangan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pedal</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pedal">-</span>
                              <span v-if="checker.checker_pedal==1">Baik</span>
                              <span v-if="checker.checker_pedal==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_pedal==3">Hilang</span>
                              <span v-if="checker.checker_pedal==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pedal_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pedal_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Posisi Stir dan Klakson</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_posisi_stir_dan_klakson">-</span>
                              <span v-if="checker.checker_posisi_stir_dan_klakson==1">Baik</span>
                              <span v-if="checker.checker_posisi_stir_dan_klakson==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_posisi_stir_dan_klakson==3">Hilang</span>
                              <span v-if="checker.checker_posisi_stir_dan_klakson==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_posisi_stir_dan_klakson_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_posisi_stir_dan_klakson_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kartu Oli dan Maintenance</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kartu_oli_dan_maintenance">-</span>
                              <span v-if="checker.checker_kartu_oli_dan_maintenance==1">Baik</span>
                              <span v-if="checker.checker_kartu_oli_dan_maintenance==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_kartu_oli_dan_maintenance==3">Hilang</span>
                              <span v-if="checker.checker_kartu_oli_dan_maintenance==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kartu_oli_dan_maintenance_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kartu_oli_dan_maintenance_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Wiper Depan/Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_wiper_depan_belakang">-</span>
                              <span v-if="checker.checker_wiper_depan_belakang==1">Baik</span>
                              <span v-if="checker.checker_wiper_depan_belakang==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_wiper_depan_belakang==3">Hilang</span>
                              <span v-if="checker.checker_wiper_depan_belakang==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_wiper_depan_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_wiper_depan_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Sign</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_sign">-</span>
                              <span v-if="checker.checker_lampu_sign==1">Baik</span>
                              <span v-if="checker.checker_lampu_sign==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_sign==3">Hilang</span>
                              <span v-if="checker.checker_lampu_sign==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_sign_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_sign_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Baca</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_baca">-</span>
                              <span v-if="checker.checker_lampu_baca==1">Baik</span>
                              <span v-if="checker.checker_lampu_baca==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_baca==3">Hilang</span>
                              <span v-if="checker.checker_lampu_baca==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_baca_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_baca_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Utama Depan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_utama_depan">-</span>
                              <span v-if="checker.checker_lampu_utama_depan==1">Baik</span>
                              <span v-if="checker.checker_lampu_utama_depan==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_utama_depan==3">Hilang</span>
                              <span v-if="checker.checker_lampu_utama_depan==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_utama_depan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_utama_depan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Rem</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_rem">-</span>
                              <span v-if="checker.checker_lampu_rem==1">Baik</span>
                              <span v-if="checker.checker_lampu_rem==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_rem==3">Hilang</span>
                              <span v-if="checker.checker_lampu_rem==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_rem_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_rem_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Mundur</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_mundur">-</span>
                              <span v-if="checker.checker_lampu_mundur==1">Baik</span>
                              <span v-if="checker.checker_lampu_mundur==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_mundur==3">Hilang</span>
                              <span v-if="checker.checker_lampu_mundur==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_mundur_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_mundur_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Power Window</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_power_window">-</span>
                              <span v-if="checker.checker_power_window==1">Baik</span>
                              <span v-if="checker.checker_power_window==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_power_window==3">Hilang</span>
                              <span v-if="checker.checker_power_window==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_power_window_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_power_window_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Central Lock</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_central_lock">-</span>
                              <span v-if="checker.checker_central_lock==1">Baik</span>
                              <span v-if="checker.checker_central_lock==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_central_lock==3">Hilang</span>
                              <span v-if="checker.checker_central_lock==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_central_lock_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_central_lock_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Elektrik Mirror</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_elektrik_mirror">-</span>
                              <span v-if="checker.checker_elektrik_mirror==1">Baik</span>
                              <span v-if="checker.checker_elektrik_mirror==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_elektrik_mirror==3">Hilang</span>
                              <span v-if="checker.checker_elektrik_mirror==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_elektrik_mirror_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_elektrik_mirror_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">AC</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_ac">-</span>
                              <span v-if="checker.checker_ac==1">Baik</span>
                              <span v-if="checker.checker_ac==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_ac==3">Hilang</span>
                              <span v-if="checker.checker_ac==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_ac_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_ac_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">STNK</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_stnk">-</span>
                              <span v-if="checker.checker_stnk==1">Baik</span>
                              <span v-if="checker.checker_stnk==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_stnk==3">Hilang</span>
                              <span v-if="checker.checker_stnk==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_stnk_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_stnk_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lighter</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lighter">-</span>
                              <span v-if="checker.checker_lighter==1">Baik</span>
                              <span v-if="checker.checker_lighter==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lighter==3">Hilang</span>
                              <span v-if="checker.checker_lighter==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lighter_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lighter_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Safety Belt</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_safety_belt">-</span>
                              <span v-if="checker.checker_safety_belt==1">Baik</span>
                              <span v-if="checker.checker_safety_belt==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_safety_belt==3">Hilang</span>
                              <span v-if="checker.checker_safety_belt==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_safety_belt_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_safety_belt_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Head Rest</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_head_rest">-</span>
                              <span v-if="checker.checker_head_rest==1">Baik</span>
                              <span v-if="checker.checker_head_rest==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_head_rest==3">Hilang</span>
                              <span v-if="checker.checker_head_rest==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_head_rest_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_head_rest_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Head Unit</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_head_unit">-</span>
                              <span v-if="checker.checker_head_unit==1">Baik</span>
                              <span v-if="checker.checker_head_unit==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_head_unit==3">Hilang</span>
                              <span v-if="checker.checker_head_unit==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_head_unit_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_head_unit_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Remote Head Unit</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_remote_head_unit">-</span>
                              <span v-if="checker.checker_remote_head_unit==1">Baik</span>
                              <span v-if="checker.checker_remote_head_unit==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_remote_head_unit==3">Hilang</span>
                              <span v-if="checker.checker_remote_head_unit==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_remote_head_unit_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_remote_head_unit_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">MCCS</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_mccs">-</span>
                              <span v-if="checker.checker_mccs==1">Baik</span>
                              <span v-if="checker.checker_mccs==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_mccs==3">Hilang</span>
                              <span v-if="checker.checker_mccs==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_mccs_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_mccs_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Sarung Jok</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_sarung_jok">-</span>
                              <span v-if="checker.checker_sarung_jok==1">Baik</span>
                              <span v-if="checker.checker_sarung_jok==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_sarung_jok==3">Hilang</span>
                              <span v-if="checker.checker_sarung_jok==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_sarung_jok_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_sarung_jok_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Karpet Dasar</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_karpet_dasar">-</span>
                              <span v-if="checker.checker_karpet_dasar==1">Baik</span>
                              <span v-if="checker.checker_karpet_dasar==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_karpet_dasar==3">Hilang</span>
                              <span v-if="checker.checker_karpet_dasar==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_karpet_dasar_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_karpet_dasar_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Asbak Depan/Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_asbak_depan_belakang">-</span>
                              <span v-if="checker.checker_asbak_depan_belakang==1">Baik</span>
                              <span v-if="checker.checker_asbak_depan_belakang==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_asbak_depan_belakang==3">Hilang</span>
                              <span v-if="checker.checker_asbak_depan_belakang==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_asbak_depan_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_asbak_depan_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Speedometer</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_speedometer">-</span>
                              <span v-if="checker.checker_speedometer==1">Baik</span>
                              <span v-if="checker.checker_speedometer==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_speedometer==3">Hilang</span>
                              <span v-if="checker.checker_speedometer==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_speedometer_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_speedometer_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image1"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_dalam" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                    
                </v-card>


                
              </md-tab>
              <md-tab id="tab-aa" md-label="Luar Mobil">
                <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam2"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item2">
                      Item
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image2">
                      Image
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam2">
                    <v-tab-item
                      value="tab_bag_dalam-item2"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>ITEM</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>CHECK</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>REMARK</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Cat Kap Mesin</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_cat_kap_mesin">-</span>
                              <span v-if="checker.checker_cat_kap_mesin==1">Baik</span>
                              <span v-if="checker.checker_cat_kap_mesin==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_cat_kap_mesin==3">Hilang</span>
                              <span v-if="checker.checker_cat_kap_mesin==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_cat_kap_mesin_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_cat_kap_mesin_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Cat Bumper Spakboard</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_cat_bumper_spakboard">-</span>
                              <span v-if="checker.checker_cat_bumper_spakboard==1">Baik</span>
                              <span v-if="checker.checker_cat_bumper_spakboard==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_cat_bumper_spakboard==3">Hilang</span>
                              <span v-if="checker.checker_cat_bumper_spakboard==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_cat_bumper_spakboard_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_cat_bumper_spakboard_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Cat Pintu</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_cat_pintu">-</span>
                              <span v-if="checker.checker_cat_pintu==1">Baik</span>
                              <span v-if="checker.checker_cat_pintu==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_cat_pintu==3">Hilang</span>
                              <span v-if="checker.checker_cat_pintu==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_cat_pintu_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_cat_pintu_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Mika Lampu</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_mika_lampu">-</span>
                              <span v-if="checker.checker_mika_lampu==1">Baik</span>
                              <span v-if="checker.checker_mika_lampu==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_mika_lampu==3">Hilang</span>
                              <span v-if="checker.checker_mika_lampu==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_mika_lampu_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_mika_lampu_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Ban</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_ban">-</span>
                              <span v-if="checker.checker_ban==1">Baik</span>
                              <span v-if="checker.checker_ban==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_ban==3">Hilang</span>
                              <span v-if="checker.checker_ban==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_ban_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_ban_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Velg</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_velg">-</span>
                              <span v-if="checker.checker_velg==1">Baik</span>
                              <span v-if="checker.checker_velg==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_velg==3">Hilang</span>
                              <span v-if="checker.checker_velg==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_velg_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_velg_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Dop Roda</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_dop_roda">-</span>
                              <span v-if="checker.checker_dop_roda==1">Baik</span>
                              <span v-if="checker.checker_dop_roda==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_dop_roda==3">Hilang</span>
                              <span v-if="checker.checker_dop_roda==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_dop_roda_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_dop_roda_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kembang Ban</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kembang_ban">-</span>
                              <span v-if="checker.checker_kembang_ban==1">Baik</span>
                              <span v-if="checker.checker_kembang_ban==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_kembang_ban==3">Hilang</span>
                              <span v-if="checker.checker_kembang_ban==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kembang_ban_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kembang_ban_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Film</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_film">-</span>
                              <span v-if="checker.checker_kaca_film==1">Baik</span>
                              <span v-if="checker.checker_kaca_film==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_kaca_film==3">Hilang</span>
                              <span v-if="checker.checker_kaca_film==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_film_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_film_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kunci Pintu</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kunci_pintu">-</span>
                              <span v-if="checker.checker_kunci_pintu==1">Baik</span>
                              <span v-if="checker.checker_kunci_pintu==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_kunci_pintu==3">Hilang</span>
                              <span v-if="checker.checker_kunci_pintu==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kunci_pintu_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kunci_pintu_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Emblem Sticker</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_emblem_sticker">-</span>
                              <span v-if="checker.checker_emblem_sticker==1">Baik</span>
                              <span v-if="checker.checker_emblem_sticker==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_emblem_sticker==3">Hilang</span>
                              <span v-if="checker.checker_emblem_sticker==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_emblem_sticker_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_emblem_sticker_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Ban Cadangan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_ban_cadangan">-</span>
                              <span v-if="checker.checker_ban_cadangan==1">Baik</span>
                              <span v-if="checker.checker_ban_cadangan==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_ban_cadangan==3">Hilang</span>
                              <span v-if="checker.checker_ban_cadangan==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_ban_cadangan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_ban_cadangan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image2"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_luar" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </md-tab>
              <md-tab id="tab-bb" md-label="Mesin Mobil">
                <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam3"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item3">
                      Item
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image3">
                      Image
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam3">
                    <v-tab-item
                      value="tab_bag_dalam-item3"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>ITEM</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>CHECK</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>REMARK</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Oli Mesin</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_oli_mesin">-</span>
                              <span v-if="checker.checker_oli_mesin==1">Baik</span>
                              <span v-if="checker.checker_oli_mesin==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_oli_mesin==3">Hilang</span>
                              <span v-if="checker.checker_oli_mesin==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_oli_mesin_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_oli_mesin_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Air dan Tutup Radiator</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_air_dan_tutup_radiator">-</span>
                              <span v-if="checker.checker_air_dan_tutup_radiator==1">Baik</span>
                              <span v-if="checker.checker_air_dan_tutup_radiator==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_air_dan_tutup_radiator==3">Hilang</span>
                              <span v-if="checker.checker_air_dan_tutup_radiator==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_air_dan_tutup_radiator_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_air_dan_tutup_radiator_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Accu</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_accu">-</span>
                              <span v-if="checker.checker_accu==1">Baik</span>
                              <span v-if="checker.checker_accu==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_accu==3">Hilang</span>
                              <span v-if="checker.checker_accu==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_accu_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_accu_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Tali Kipas</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_tali_kipas">-</span>
                              <span v-if="checker.checker_tali_kipas==1">Baik</span>
                              <span v-if="checker.checker_tali_kipas==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_tali_kipas==3">Hilang</span>
                              <span v-if="checker.checker_tali_kipas==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_tali_kipas_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_tali_kipas_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image3"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_mesin" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </md-tab>
              <md-tab id="tab-cc" md-label="Perlengkapan Lain">
                <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam4"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item4">
                      Item
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image4">
                      Image
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam4">
                    <v-tab-item
                      value="tab_bag_dalam-item4"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>ITEM</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>CHECK</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>REMARK</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Dongkrak</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_dongkrak">-</span>
                              <span v-if="checker.checker_dongkrak==1">Baik</span>
                              <span v-if="checker.checker_dongkrak==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_dongkrak==3">Hilang</span>
                              <span v-if="checker.checker_dongkrak==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_dongkrak_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_dongkrak_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Ban Serep dan Kunci Roda</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_ban_serep_dan_kunci_roda">-</span>
                              <span v-if="checker.checker_ban_serep_dan_kunci_roda==1">Baik</span>
                              <span v-if="checker.checker_ban_serep_dan_kunci_roda==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_ban_serep_dan_kunci_roda==3">Hilang</span>
                              <span v-if="checker.checker_ban_serep_dan_kunci_roda==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_ban_serep_dan_kunci_roda_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_ban_serep_dan_kunci_roda_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Segitiga Pengaman</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_segitiga_pengaman">-</span>
                              <span v-if="checker.checker_segitiga_pengaman==1">Baik</span>
                              <span v-if="checker.checker_segitiga_pengaman==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_segitiga_pengaman==3">Hilang</span>
                              <span v-if="checker.checker_segitiga_pengaman==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_segitiga_pengaman_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_segitiga_pengaman_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Karpet Bagasi</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_karpet_bagasi">-</span>
                              <span v-if="checker.checker_karpet_bagasi==1">Baik</span>
                              <span v-if="checker.checker_karpet_bagasi==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_karpet_bagasi==3">Hilang</span>
                              <span v-if="checker.checker_karpet_bagasi==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_karpet_bagasi_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_karpet_bagasi_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">P3K</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_p3k">-</span>
                              <span v-if="checker.checker_p3k==1">Baik</span>
                              <span v-if="checker.checker_p3k==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_p3k==3">Hilang</span>
                              <span v-if="checker.checker_p3k==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_p3k_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_p3k_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image4"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_lain" :key="index">
                            <md-table-cell>
                              <viewer style="margin:auto;" class="pointer photo_list" :src="item.url_photo_file">
                                <img :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </md-tab>
              <md-tab id="tab-1" md-label="Kelengkapan Taksi">
                <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam5"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item5">
                      Item
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image5">
                      Image
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam5">
                    <v-tab-item
                      value="tab_bag_dalam-item5"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>ITEM</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>CHECK</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>REMARK</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Mahkota</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_mahkota">-</span>
                              <span v-if="checker.checker_mahkota==1">Baik</span>
                              <span v-if="checker.checker_mahkota==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_mahkota==3">Hilang</span>
                              <span v-if="checker.checker_mahkota==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_mahkota_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_mahkota_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Argometer</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_argometer">-</span>
                              <span v-if="checker.checker_argometer==1">Baik</span>
                              <span v-if="checker.checker_argometer==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_argometer==3">Hilang</span>
                              <span v-if="checker.checker_argometer==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_argometer_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_argometer_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Bahaya</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_bahaya">-</span>
                              <span v-if="checker.checker_lampu_bahaya==1">Baik</span>
                              <span v-if="checker.checker_lampu_bahaya==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_bahaya==3">Hilang</span>
                              <span v-if="checker.checker_lampu_bahaya==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_bahaya_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_bahaya_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Sticker Atribut Taksi</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_sticker_atribut_taksi">-</span>
                              <span v-if="checker.checker_sticker_atribut_taksi==1">Baik</span>
                              <span v-if="checker.checker_sticker_atribut_taksi==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_sticker_atribut_taksi==3">Hilang</span>
                              <span v-if="checker.checker_sticker_atribut_taksi==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_sticker_atribut_taksi_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_sticker_atribut_taksi_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Lampu Vacant</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_lampu_vacant">-</span>
                              <span v-if="checker.checker_lampu_vacant==1">Baik</span>
                              <span v-if="checker.checker_lampu_vacant==2">Tidak Baik/Rusak</span>
                              <span v-if="checker.checker_lampu_vacant==3">Hilang</span>
                              <span v-if="checker.checker_lampu_vacant==4">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_lampu_vacant_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_lampu_vacant_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image5"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_taxi" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </md-tab>
              <md-tab id="tab-2" md-label="Body Mobil">
                <v-card>
                  <v-tabs
                    v-model="tab_bag_dalam6"
                    background-color="transparent"
                    centered
                    style="margin-bottom:20px; "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab_bag_dalam-item6">
                      Item
                    </v-tab>
                    <v-tab href="#tab_bag_dalam-image6">
                      Image
                    </v-tab>
                  </v-tabs>
                  
                  <v-tabs-items v-model="tab_bag_dalam6">
                    <v-tab-item
                      value="tab_bag_dalam-item6"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:left;"><b>ITEM</b></md-table-head>
                            <md-table-head style="text-align:left;"><b>CHECK</b></md-table-head>
                            <md-table-head style="text-align:center;"><b>REMARK</b></md-table-head>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kap Mesin</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kap_mesin">-</span>
                              <span v-if="checker.checker_kap_mesin==1">Penyot</span>
                              <span v-if="checker.checker_kap_mesin==2">Lecet</span>
                              <span v-if="checker.checker_kap_mesin==3">Baret</span>
                              <span v-if="checker.checker_kap_mesin==4">Dekok</span>
                              <span v-if="checker.checker_kap_mesin==5">Pecah</span>
                              <span v-if="checker.checker_kap_mesin==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kap_mesin_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kap_mesin_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Fender Depan Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_fender_depan_kiri">-</span>
                              <span v-if="checker.checker_fender_depan_kiri==1">Penyot</span>
                              <span v-if="checker.checker_fender_depan_kiri==2">Lecet</span>
                              <span v-if="checker.checker_fender_depan_kiri==3">Baret</span>
                              <span v-if="checker.checker_fender_depan_kiri==4">Dekok</span>
                              <span v-if="checker.checker_fender_depan_kiri==5">Pecah</span>
                              <span v-if="checker.checker_fender_depan_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_fender_depan_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_fender_depan_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Fender Depan Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_fender_depan_kanan">-</span>
                              <span v-if="checker.checker_fender_depan_kanan==1">Penyot</span>
                              <span v-if="checker.checker_fender_depan_kanan==2">Lecet</span>
                              <span v-if="checker.checker_fender_depan_kanan==3">Baret</span>
                              <span v-if="checker.checker_fender_depan_kanan==4">Dekok</span>
                              <span v-if="checker.checker_fender_depan_kanan==5">Pecah</span>
                              <span v-if="checker.checker_fender_depan_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_fender_depan_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_fender_depan_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Spion Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_spion_kiri">-</span>
                              <span v-if="checker.checker_spion_kiri==1">Penyot</span>
                              <span v-if="checker.checker_spion_kiri==2">Lecet</span>
                              <span v-if="checker.checker_spion_kiri==3">Baret</span>
                              <span v-if="checker.checker_spion_kiri==4">Dekok</span>
                              <span v-if="checker.checker_spion_kiri==5">Pecah</span>
                              <span v-if="checker.checker_spion_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_spion_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_spion_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Spion Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_spion_kanan">-</span>
                              <span v-if="checker.checker_spion_kanan==1">Penyot</span>
                              <span v-if="checker.checker_spion_kanan==2">Lecet</span>
                              <span v-if="checker.checker_spion_kanan==3">Baret</span>
                              <span v-if="checker.checker_spion_kanan==4">Dekok</span>
                              <span v-if="checker.checker_spion_kanan==5">Pecah</span>
                              <span v-if="checker.checker_spion_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_spion_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_spion_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Bemper Depan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_bemper_depan">-</span>
                              <span v-if="checker.checker_bemper_depan==1">Penyot</span>
                              <span v-if="checker.checker_bemper_depan==2">Lecet</span>
                              <span v-if="checker.checker_bemper_depan==3">Baret</span>
                              <span v-if="checker.checker_bemper_depan==4">Dekok</span>
                              <span v-if="checker.checker_bemper_depan==5">Pecah</span>
                              <span v-if="checker.checker_bemper_depan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_bemper_depan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_bemper_depan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Depan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_depan">-</span>
                              <span v-if="checker.checker_kaca_depan==1">Penyot</span>
                              <span v-if="checker.checker_kaca_depan==2">Lecet</span>
                              <span v-if="checker.checker_kaca_depan==3">Baret</span>
                              <span v-if="checker.checker_kaca_depan==4">Dekok</span>
                              <span v-if="checker.checker_kaca_depan==5">Pecah</span>
                              <span v-if="checker.checker_kaca_depan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_depan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_depan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_belakang">-</span>
                              <span v-if="checker.checker_kaca_belakang==1">Penyot</span>
                              <span v-if="checker.checker_kaca_belakang==2">Lecet</span>
                              <span v-if="checker.checker_kaca_belakang==3">Baret</span>
                              <span v-if="checker.checker_kaca_belakang==4">Dekok</span>
                              <span v-if="checker.checker_kaca_belakang==5">Pecah</span>
                              <span v-if="checker.checker_kaca_belakang==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Pintu Depan Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_pintu_depan_kiri">-</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==1">Penyot</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==2">Lecet</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==3">Baret</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==4">Dekok</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==5">Pecah</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_pintu_depan_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_pintu_depan_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Pintu Depan Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_pintu_depan_kanan">-</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==1">Penyot</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==2">Lecet</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==3">Baret</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==4">Dekok</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==5">Pecah</span>
                              <span v-if="checker.checker_kaca_pintu_depan_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_pintu_depan_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_pintu_depan_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Kaca Pintu Belakang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_kaca_pintu_belakang_kiri">-</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==3">Baret</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_kaca_pintu_belakang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_kaca_pintu_belakang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_kaca_pintu_belakang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Depan Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_depan_kanan">-</span>
                              <span v-if="checker.checker_pintu_depan_kanan==1">Penyot</span>
                              <span v-if="checker.checker_pintu_depan_kanan==2">Lecet</span>
                              <span v-if="checker.checker_pintu_depan_kanan==3">Baret</span>
                              <span v-if="checker.checker_pintu_depan_kanan==4">Dekok</span>
                              <span v-if="checker.checker_pintu_depan_kanan==5">Pecah</span>
                              <span v-if="checker.checker_pintu_depan_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_depan_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_depan_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Belakang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_belakang_kiri">-</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==3">Baret</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_pintu_belakang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_belakang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_belakang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Depan Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_depan_kiri">-</span>
                              <span v-if="checker.checker_pintu_depan_kiri==1">Penyot</span>
                              <span v-if="checker.checker_pintu_depan_kiri==2">Lecet</span>
                              <span v-if="checker.checker_pintu_depan_kiri==3">Baret</span>
                              <span v-if="checker.checker_pintu_depan_kiri==4">Dekok</span>
                              <span v-if="checker.checker_pintu_depan_kiri==5">Pecah</span>
                              <span v-if="checker.checker_pintu_depan_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_depan_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_depan_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Belakang Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_belakang_kanan">-</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==1">Penyot</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==2">Lecet</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==3">Baret</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==4">Dekok</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==5">Pecah</span>
                              <span v-if="checker.checker_pintu_belakang_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_belakang_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_belakang_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Fender Belakang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_fender_belakang_kiri">-</span>
                              <span v-if="checker.checker_fender_belakang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_fender_belakang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_fender_belakang_kiri==3">Baret</span>
                              <span v-if="checker.checker_fender_belakang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_fender_belakang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_fender_belakang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_fender_belakang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_fender_belakang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Fender Belakang Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_fender_belakang_kanan">-</span>
                              <span v-if="checker.checker_fender_belakang_kanan==1">Penyot</span>
                              <span v-if="checker.checker_fender_belakang_kanan==2">Lecet</span>
                              <span v-if="checker.checker_fender_belakang_kanan==3">Baret</span>
                              <span v-if="checker.checker_fender_belakang_kanan==4">Dekok</span>
                              <span v-if="checker.checker_fender_belakang_kanan==5">Pecah</span>
                              <span v-if="checker.checker_fender_belakang_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_fender_belakang_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_fender_belakang_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Atap Remark</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_atap_remark">-</span>
                              <span v-if="checker.checker_atap_remark==1">Penyot</span>
                              <span v-if="checker.checker_atap_remark==2">Lecet</span>
                              <span v-if="checker.checker_atap_remark==3">Baret</span>
                              <span v-if="checker.checker_atap_remark==4">Dekok</span>
                              <span v-if="checker.checker_atap_remark==5">Pecah</span>
                              <span v-if="checker.checker_atap_remark==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_atap_remark_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_atap_remark_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Pintu Belakang</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_pintu_belakang">-</span>
                              <span v-if="checker.checker_pintu_belakang==1">Penyot</span>
                              <span v-if="checker.checker_pintu_belakang==2">Lecet</span>
                              <span v-if="checker.checker_pintu_belakang==3">Baret</span>
                              <span v-if="checker.checker_pintu_belakang==4">Dekok</span>
                              <span v-if="checker.checker_pintu_belakang==5">Pecah</span>
                              <span v-if="checker.checker_pintu_belakang==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_pintu_belakang_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_pintu_belakang_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Roda Depan Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_roda_depan_kiri">-</span>
                              <span v-if="checker.checker_roda_depan_kiri==1">Penyot</span>
                              <span v-if="checker.checker_roda_depan_kiri==2">Lecet</span>
                              <span v-if="checker.checker_roda_depan_kiri==3">Baret</span>
                              <span v-if="checker.checker_roda_depan_kiri==4">Dekok</span>
                              <span v-if="checker.checker_roda_depan_kiri==5">Pecah</span>
                              <span v-if="checker.checker_roda_depan_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_roda_depan_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_roda_depan_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Roda Depan Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_roda_depan_kanan">-</span>
                              <span v-if="checker.checker_roda_depan_kanan==1">Penyot</span>
                              <span v-if="checker.checker_roda_depan_kanan==2">Lecet</span>
                              <span v-if="checker.checker_roda_depan_kanan==3">Baret</span>
                              <span v-if="checker.checker_roda_depan_kanan==4">Dekok</span>
                              <span v-if="checker.checker_roda_depan_kanan==5">Pecah</span>
                              <span v-if="checker.checker_roda_depan_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_roda_depan_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_roda_depan_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Roda Belakang Kiri</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_roda_belakang_kiri">-</span>
                              <span v-if="checker.checker_roda_belakang_kiri==1">Penyot</span>
                              <span v-if="checker.checker_roda_belakang_kiri==2">Lecet</span>
                              <span v-if="checker.checker_roda_belakang_kiri==3">Baret</span>
                              <span v-if="checker.checker_roda_belakang_kiri==4">Dekok</span>
                              <span v-if="checker.checker_roda_belakang_kiri==5">Pecah</span>
                              <span v-if="checker.checker_roda_belakang_kiri==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_roda_belakang_kiri_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_roda_belakang_kiri_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                          <md-table-row>
                            <md-table-cell style="text-align:left; font-weight:bold;">Roda Belakang Kanan</md-table-cell>
                            <md-table-cell style="text-align:left;">
                              <span v-if="!checker.checker_roda_belakang_kanan">-</span>
                              <span v-if="checker.checker_roda_belakang_kanan==1">Penyot</span>
                              <span v-if="checker.checker_roda_belakang_kanan==2">Lecet</span>
                              <span v-if="checker.checker_roda_belakang_kanan==3">Baret</span>
                              <span v-if="checker.checker_roda_belakang_kanan==4">Dekok</span>
                              <span v-if="checker.checker_roda_belakang_kanan==5">Pecah</span>
                              <span v-if="checker.checker_roda_belakang_kanan==6">N/A</span>
                            </md-table-cell>
                            <md-table-cell style="text-align:center;">
                              <span v-if="!checker.checker_roda_belakang_kanan_remark" style="color:#aaa; width:150px;">-</span>
                              <span v-else>{{ checker.checker_roda_belakang_kanan_remark }}</span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      value="tab_bag_dalam-image6"
                    >
                      <v-card flat>
                        <md-table>
                          <md-table-row>
                            <md-table-head style="text-align:center;">Photo</md-table-head>
                            <md-table-head style="text-align:left;">Remark</md-table-head>
                          </md-table-row>
                          <md-table-row v-for="(item,index)  in checker.checker_image_bagian_body" :key="index">
                            <md-table-cell>
                              <viewer class="pointer" :src="item.url_photo_file">
                                <img  style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_photo_file" :alt="'Bagian Dalam '+index" >
                              </viewer></md-table-cell>
                            <md-table-cell> {{ item.photo_remark }}</md-table-cell>
                          </md-table-row>
                        </md-table>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </md-tab>
            </md-tabs>
          </template>
        </nav-tabs-card> -->
      </div>
    </div>
       
          
    <div v-bind:style="{ display: not_found }">
      <center  v-if="checker ||checker == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List Checker?</a>
        </p>
      </center>
    </div>
    </v-app>
  </div>
  <!-- aaaa -->
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Swal from 'sweetalert2';
import { NavTabsCard, Tabs } from "@/components";
import vuetify from '@/plugins/vuetify'
export default {
  name: "detail-service-estimates",

  // props: {
  //   checker: Object,
  // },

  components: {
    // NavTabsCard
    Tabs

  },

  props: { data_id: null },

  
  vuetify,

  data: () => ({
    not_found: 'none',
    role:"",
    checker: null,
    tab_bag_dalam1: null,
    tab_bag_dalam2: null,
    tab_bag_dalam3: null,
    tab_bag_dalam4: null,
    tab_bag_dalam5: null,
    tab_bag_dalam6: null,
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  }),

  created() {
    this.getCheckerData();
  },

  methods: {
    //fungsi yang berjalan saat page pertamakali dibuka
    async getCheckerData(){
      //ambil list role permission user
      this.role =  await this.$store.getters["role_permission/route_filter"]
      console.log(this.role)
      //ambil data se sesuai dengan id yang ikut juga dikirim melalui route
      await this.$store.dispatch("workshop_checker/get", this.data_id.id)
      this.checker = await this.$store.getters["workshop_checker/checker"]

       //check apakah data dari api ada
        if(!this.checker){
          //jika tidak ada munculkan not found yang defaultnya di hide
          this.not_found = "block"
          return
        }
    },

    closeDetail(){
      this.$parent.$parent.modalCloseDetail();
    },

    // direct ke edit form
    editChecker(id) {
      //pindah ke page edit, id juga ikut dikirim melalui route
      this.$router.push({ name: 'Edit Checker', params: {checker: id, id } })
    },
    
    // direct ke list view table
    backToList() {
      //kembali ke list
      this.$router.replace({ name: 'List Checker'})
    },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.deleteChecker(id)
        }
      });
    },
    
    // fungsi delete data
    async deleteChecker(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("workshop_checker/destroy", id)
        //panggil alert succes
        await this.$store.dispatch("alerts/success", "User data delete successfully.")
        //kembali ke page list
        this.$router.replace({ name: 'List Checker'})
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }
    },
    
    
    printPage(){
      window.print()
    }
      
  }
};
</script>
<style scoped>
.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
@media print{
   .print{
       visibility: visible;
       zoom: 80%;
      margin: none;
   }
   .noprint{
     display: none;
   }
   /* content {transform: scale(.5);}
    .md-card {page-break-inside: avoid;} */

  
}

/* .md-layout{
  background-color: white;
} */

.md-card{
  box-shadow: 0 3px 5px 1px rgb(0 0 0/ 14%);
 
}
.sub-tab-item{
  margin-top: 2rem;
}

.photo_list{
    max-width: 50%;
    height: auto;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
}
</style>